import React from 'react';
import '../App.css'

class Education extends React.Component {

    render() {
      return (
        <div className="experience">
          <div className='linkedin_container'>
            <h1>Education</h1>
          
          
            {this.props.data.map((value, i) => {
              return (<div style={{textAlign:'left', marginLeft:'1em', marginBottom:'1em', marginRight:'1em'}}>
                <b>{value.school}</b><span style={{float:'right'}}>{value.location}</span>
                <div className="custom_break"></div>
                <i>{value.degree}</i><span style={{float:'right'}}>{value.end_date}</span>
                <div className="custom_break"></div>
                <uo>
                    <li>Major: {value.major}</li>
                    <li>Honors/Awards: {value.honors}</li>
                    <li>GPA: {value.gpa}</li>
                </uo>
                </div>
                
              )
            })}
          </div>
        </div>
      )
    }
}

export default Education;